import React from "react";

export function useDebounce<T>(intervalMilliseconds: number, initialValue?: T): [T, (value: T, instant?: boolean) => void] {
	const [val, setVal] = React.useState<any>(initialValue);
	const h = React.useRef();

	function updateVal(value: T, instant?: boolean) {
		if (instant) {
			setVal(value);
			return;
		}

		if (h.current) clearTimeout(h.current);

		h.current = setTimeout(() => {
			setVal(value as any);
			h.current = undefined;
		}, intervalMilliseconds) as any;	
	}

	return [val as T, updateVal];
}

export function useDelayedDebounce<T>(
	intervalMilliseconds: number,
	initialValue: T,
	update: () => T,

): [T, () => void] {

	const [val, setVal] = React.useState<any>(initialValue);
	const h = React.useRef();

	function requestUpdate() {

		if (h.current) clearTimeout(h.current);

		h.current = setTimeout(() => {
			// now that time elapsed, fetch the value
			const value = update();
			setVal(value);
			h.current = undefined;
		}, intervalMilliseconds) as any;	
	}

	return [val as T, requestUpdate];
}